<!------------------------------

      Page Actions

------------------------------->

<ng-container *sbPageAction>
  <button
    *ngPermissions="permissionService.Permission.client_user_create"
    sb-button-primary
    type="button"
    [color]="'green'"
    icon="plus"
    [sbTooltip]="'lang.globals.newUser' | translate"
    [iconButton]="true"
    [queryParams]="{returnTo: util.getPageLink()}"
    [sbRouterLink]="util.RoutingID.planningCreate">
  </button>
  <button
    type="button"
    sb-button-primary
    icon="refresh"
    [iconButton]="true"
    [color]="'blue'"
    (click)="requestDebounced()"
    [disabled]="loading()"
    [loading]="loading()"
    sbTooltip="{{ 'lang.globals.refresh' | translate }}" container="body"
    placement="top">
  </button>
</ng-container>

<!------------------------------

     Table Wrapper

------------------------------->

@let ordering = orderOption();

<div class="tw-min-h-[500px]">
  <sb-table-wrapper-new
    headline="{{'lang.headlines.users' | translate}}"
    [itemsData]="users"
    (paginationChange)="requestDebounced($event)"
    [loading]="loading()"
    [itemName]="'users'"
    [isInIntegratedContext]="true">

    <!------------------------------

       Filter Panel

   ------------------------------->
    <div filter-panel class="tw-bg-[#F8F9FC] dark:tw-bg-sbGray-930 tw-rounded-l-xl">
      <sb-filter-panel
        #FilterPanelRef
        (filterChange)="applyFiltering($event)"
        [headerClasses]="'tw-bg-sbGray-50 dark:tw-bg-sbGray-930 tw-border-solid tw-border-0 tw-z-40 tw-border-b tw-border-sbGray-500 dark:tw-border-sbGray-50 tw-h-[60px] tw-rounded-tl-xl'"
        [config]="filterConfig"
        filterID="search"
      >
        <sb-filter-section *ngPermissions="permissionService.Permission.role_list" title="{{'lang.globals.roles' | translate}}"
                           icon="userRoles">
          <sb-filter-dto-list-select filterID="roles" [endpoint]="api.ca_am_Role_retrieveAll.bind(api)">
          </sb-filter-dto-list-select>
        </sb-filter-section>
        <sb-filter-section title="{{'lang.globals.permissions' | translate}}"
                           icon="key">
          <sb-filter-string-list-select filterID="permissions" [endpoint]="api.shared_Permission_retrieveAll.bind(api)"
                                        [translatePrefix]="'permission.'">
          </sb-filter-string-list-select>
        </sb-filter-section>

        <ng-template #orderSection>
          <sb-filter-section
            [alwaysExpanded]="true" [hideValueIndicatorIfDefaultSelected]="true" [showTag]="false"
            title="{{'lang.globals.order' | translate}}" icon="sort">
            <sb-filter-order
              [allOrderOptions]="allOrderOptions|omit: 'direction'"
              [selectedOrderOption]="orderOption()"
            >
            </sb-filter-order>
          </sb-filter-section>
        </ng-template>
      </sb-filter-panel>
    </div>

    <!------------------------------

        Table Header

  ------------------------------->
    <ng-template #thead>
      <tr>
        <th>{{ 'lang.globals.status' | translate }}</th>
        <th>{{ 'lang.userEdit.lastLogin'| translate }}</th>
        <th>{{ 'lang.globals.id' | translate }}</th>
        <th class="table--sortable"
            (click)="setToOrderAndRefresh(ca_am_User_retrieveAll_order.USER_LASTNAME)"
            [ngClass]="{'table--sorted': ordering.value===ca_am_User_retrieveAll_order.USER_LASTNAME}">
          {{ 'lang.globals.lastName' | translate }}
          @if (ordering.value === ca_am_User_retrieveAll_order.USER_LASTNAME) {
            @if (ordering.direction === 'desc') {
              <sb-icon icon="sortDownFilled" class="icon-in-btn"></sb-icon>
            } @else {
              <sb-icon icon="sortUpFilled" class="icon-in-btn"></sb-icon>
            }
          } @else {
            <sb-icon icon="arrowsExchangeVAlt" class="icon-in-btn"></sb-icon>
          }

        </th>
        <th class="table--sortable"
            (click)="setToOrderAndRefresh(ca_am_User_retrieveAll_order.USER_FIRSTNAME)"
            [ngClass]="{'table--sorted': ordering.value===ca_am_User_retrieveAll_order.USER_FIRSTNAME}">
          {{ 'lang.globals.firstName' | translate }}
          @if (ordering.value === ca_am_User_retrieveAll_order.USER_FIRSTNAME) {
            @if (ordering.direction === 'desc') {
              <sb-icon icon="sortDownFilled" class="icon-in-btn"></sb-icon>
            } @else {
              <sb-icon icon="sortUpFilled" class="icon-in-btn"></sb-icon>
            }
          } @else {
            <sb-icon icon="arrowsExchangeVAlt" class="icon-in-btn"></sb-icon>
          }
        </th>
        <th class="table--sortable"
            (click)="setToOrderAndRefresh(ca_am_User_retrieveAll_order.USER_EMAIL)"
            [ngClass]="{'table--sorted': ordering.value===ca_am_User_retrieveAll_order.USER_EMAIL}">
          {{ 'lang.globals.email' | translate }}
          @if (ordering.value === ca_am_User_retrieveAll_order.USER_EMAIL) {
            @if (ordering.direction === 'desc') {
              <sb-icon icon="sortDownFilled" class="icon-in-btn"></sb-icon>
            } @else {
              <sb-icon icon="sortUpFilled" class="icon-in-btn"></sb-icon>
            }
          } @else {
            <sb-icon icon="arrowsExchangeVAlt" class="icon-in-btn"></sb-icon>
          }
        </th>
        <th>{{ 'lang.globals.createdAt' | translate }}</th>
        <th>{{ 'lang.globals.roles' | translate }}</th>

        <th class="sticky-col last-col"></th>
      </tr>
    </ng-template>
    <!------------------------------

      Table Body

  ------------------------------->
    <ng-template #tbody let-user>

      <tr>
        <td>
          @if (user.blocked) {

            <span [sbTooltip]="user?.blocked | date : 'dd.MM.yyyy HH:mm'" placement="right" container="body"
                  class="red font-weight-bold">
          <sb-icon icon="error"></sb-icon>
              {{ 'lang.globals.blocked' | translate }}
        </span>
          } @else {

            <span class="green font-weight-bold">
          <sb-icon icon="success"></sb-icon>
              {{ 'lang.globals.active' | translate }}
        </span>
          }
        </td>
        <td>{{ user?.lastLogin | date: 'dd.MM.yy HH:mm:ss' }}</td>
        <td>
          {{ user?.user.id }}
        </td>
        <td>
          {{ user?.user?.lastname }}
        </td>
        <td>
          {{ user?.user?.firstname }}
        </td>
        <td>
          {{ user?.user?.email }}
        </td>
        <td>
          <sb-comp-display-created [data]="user"></sb-comp-display-created>
        <td>
          <ng-container *ngFor="let s of user?.explicitRoles; index as i; last as last">
            <span *ngIf="i < 4 && !last">{{ s.name | sbDefaultRoleTranslate }}, </span>
            <span *ngIf="i < 4 && last">{{ s.name | sbDefaultRoleTranslate }}</span>
            <span *ngIf="i === 4">... ({{
                'lang.globals.countMore' | translate: {
                  count:
                    user?.explicitRoles.length - 4
                }
              }})</span>
          </ng-container>
        </td>


        <td class="sticky-col last-col">
          <div class="tw-flex tw-gap-2.5">
            <sb-split-button
              [splitButtonItems]="user.extraButtons ?? []"
              (selectedAction)="resolveSplitButtonAction(user, $event)"
            ></sb-split-button>
            <sb-split-button
              [splitButtonItems]="user.sbButtons ?? []"
              (selectedAction)="resolveSplitButtonAction(user, $event)"
            ></sb-split-button>
          </div>
        </td>
      </tr>
    </ng-template>
    <!------------------------------

  Card Element

  ------------------------------->

    <!-- no card element -->

  </sb-table-wrapper-new>
</div>
